const doneServicesOutput = {
  title: `Services Done`,
};

export default doneServicesOutput;
